const uploadUrl=`https://api.accountsir.com/workflow/fileManager/uploadFiles`
const imgShow=`https://files.mankoo.cn/`
export { uploadUrl,imgShow};



// WEBPACK FOOTER //
// ./src/assets/utils/uploadUrl.js